import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import WhatsAppBubble from "@/components/WhatsAppBubble";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import History from "@/pages/History";
import Settings from "@/pages/Settings";
import ERPSync from "@/pages/ERPSync";
import Publish from "@/pages/Publish";
import Batches from "@/pages/Batches";
import Pricing from "@/pages/Pricing";
import Checkout from "@/pages/Checkout";
import Manual from "@/pages/Manual";
import Webhooks from "@/pages/Webhooks";
import Privacy from "@/pages/Privacy";
import Support from "@/pages/Support";
import BlingHomologacao from "@/pages/BlingHomologacao";
import Landing from "@/pages/Landing";
import ManualBling from "@/pages/ManualBling";
import AdminUsers from "@/pages/AdminUsers";
import ImpersonationBanner from "@/components/ImpersonationBanner";

export default function App() {
  return (
    <div className="App" translate="no">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/manual/bling" element={<ManualBling />} />
            <Route path="/" element={<Landing />} />
            <Route
              path="/publish"
              element={
                <ProtectedRoute>
                  <Publish />
                </ProtectedRoute>
              }
            />
            <Route
              path="/batches"
              element={
                <ProtectedRoute>
                  <Batches />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/erp-sync"
              element={
                <ProtectedRoute>
                  <ERPSync />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout/:tier"
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manual"
              element={
                <ProtectedRoute>
                  <Manual />
                </ProtectedRoute>
              }
            />
            <Route
              path="/webhooks"
              element={
                <ProtectedRoute>
                  <Webhooks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bling-homologacao"
              element={
                <ProtectedRoute>
                  <BlingHomologacao />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
          </Routes>
          <WhatsAppBubble />
          <ImpersonationBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
